module.exports = __webpack_public_path__ + "img/brown-hairy-grass-00.12c79954.png";